<template>
  <ProgressBar
    :value="clampedValue"
    :class="['kpi-progress-bar', severityClass]"
    :show-value="false"
    v-bind="$attrs"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import ProgressBar from 'primevue/progressbar';

const props = withDefaults(defineProps<{
  value?: number;
  // Thresholds for color. Default: >=100 success, >=80 warning, else danger
  successThreshold?: number;
  warningThreshold?: number;
}>(), {
  value: 0,
  successThreshold: 100,
  warningThreshold: 80
});

const clampedValue = computed(() => Math.min(Math.max(props.value || 0, 0), 100));

const severityClass = computed(() => {
  const v = props.value || 0;
  if (v >= props.successThreshold) return 'kpi-progress--success';
  if (v >= props.warningThreshold) return 'kpi-progress--warning';
  return 'kpi-progress--danger';
});
</script>

<style scoped>
.kpi-progress-bar {
  height: 6px !important;
  border-radius: 4px !important;
}

.kpi-progress-bar :deep(.p-progressbar-value) {
  border-radius: 4px !important;
  transition: width 0.4s ease;
}

.kpi-progress--success :deep(.p-progressbar-value) {
  background: #10b981 !important;
}

.kpi-progress--warning :deep(.p-progressbar-value) {
  background: #f59e0b !important;
}

.kpi-progress--danger :deep(.p-progressbar-value) {
  background: #ef4444 !important;
}

.kpi-progress-bar :deep(.p-progressbar-label) {
  display: none !important;
}
</style>
